import $ from 'jquery';

const $paginationRowsSelect = $('.pagination-rows-select');

if ($paginationRowsSelect.length > 0) {
  // Set value shown in dropdown to match search params
  const perPage = (new URL(window.location)).searchParams.get('per_page') || '20';
  $paginationRowsSelect.find(`option[value="${perPage}"]`).attr('selected', true);

  // Handle 'rows per page' change
  $paginationRowsSelect.on('change', 'select', event => {
    const uri = new URL(window.location);
    const search = (new URL(window.location)).searchParams;

    search.set('per_page', event.target.value);
    uri.search = search.toString();

    window.location.href = uri.toString();
  });
}
